module.exports = __webpack_public_path__ + "static/media/480.f0538a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-snail/dark/480.png
// module id = 2446
// module chunks = 2